import './Hero.scss';
import bgAi from '../../images/bg/bg_ai.jpg';
// import bgAi from '../../images/bg/bg_ai_02.jpg';

const Hero = () => {
  return (
    <section className="hero" style={{ backgroundImage: `url(${bgAi})` }}>
      <div className="container">
        <div className="content">
          <p className="patent-badge">
            원천기술 3건 특허 출원
          </p>
          <h1 className="title">
            <span className="highlight">PDF(수식)</span>를 <span className="highlight">HWP</span>로 변환하는<br />
            AI 솔루션
          </h1>
          <p className="subtitle">수학 PDF · 수식 PDF · 낙서 PDF · 필기 PDF 를 HWP로 변환<br />수학 OCR · 수식 OCR · 수학 타이핑을 매쓰테일러로 해결</p>
        </div>
      </div>
      {/* SEO 키워드 텍스트 - 화면에 표시되지 않음 */}
      <p className="seo-keywords">나만의 문제은행 구축 HWP 문제은행 수학 문제은행 단원관리 문제출제 시험지 저장 변형문제 유사문제 풀이 낙서 PDF HWP 변환 낙서 수학기출문제 HWP 변환 수학 이미지 그리기 수학문제집 타이핑 수식 타이핑</p>
      <div className="patent-notice">
        <span className="notice-label">특허 출원 안내</span>
        <span className="notice-text">
          AI 기반 수학 문제 자동 변환 &middot; 변형 &middot; 도형 재구성 원천기술 <strong>3건 특허 출원</strong> (출원번호: 10-2026-0045117 외 2건)
        </span>
      </div>
    </section>
  );
};

export default Hero;
